import { formatNumbers, IconButtonDropdownNew } from '@lune-fe/lune-ui-lib'
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const DataSheetEstimateContextMenu: FC<{
    quantity: string | number
}> = ({ quantity }) => {
    const navigate = useNavigate()
    const [open, setOpen] = useState<boolean>(false)

    return (
        <IconButtonDropdownNew
            sx={{ ...(open && { opacity: '1 !important' }) }}
            onToggle={(isOpen) => setOpen(isOpen)}
            menuAutoWidth
            icon={<MoreVertOutlinedIcon />}
        >
            <IconButtonDropdownNew.MenuItem
                icon={<CloudDownloadOutlinedIcon />}
                title={`Offset`}
                onClick={() => navigate(`/order?amount=${formatNumbers(quantity, 2)}`)}
            />
        </IconButtonDropdownNew>
    )
}

export default DataSheetEstimateContextMenu
